import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import { FieldInterface } from 'common/types/entities/field-interface'
import { BorderStyleEnum } from 'common/types/styleTypes'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createField(
  parentId: string,
  masterBlockId?: MasterBlockId,
  options?: Partial<FieldInterface>,
): FieldInterface {
  return {
    ...generateBaseEntity(EntityTypeEnum.Field, parentId, masterBlockId),
    optional: false,
    fontSize: 18,
    backgroundColor: 'rgba(255, 255, 255, 1)',
    margin: { marginTop: 25, marginRight: 0, marginBottom: 0, marginLeft: 0 },
    mobileMargin: {
      marginTop: 10,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    padding: {
      paddingTop: 12,
      paddingRight: 0,
      paddingBottom: 12,
      paddingLeft: 0,
    },
    border: {
      radius: {
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
      },
      style: BorderStyleEnum.solid,
      color: 'rgba(176, 186, 202, 1)',
      width: 1,
    },
    ...options,
  }
}
